import styled from "styled-components";

export const StyledServiceRow = styled.div`
  display: flex;
  width: 100%;
  margin-top: 20px;
`;

export const StyledServiceList = styled.ul`
  margin: 0;
`;

export const ServiceDescription = styled.div`
  width: 75%;
`;

export const ServicePrice = styled.div`
  width: 25%;
  text-align: center;
`;
